<template>
  <div class="custom-form cmi-card-view">
    <div class="cmi-backtobasket">
      <button @click="showBasket" class="btn btn-primary btn-lg">
        Back to Basket
      </button>
    </div>
    <div class="panel panel-primary">
      <div class="panel-heading">
        <h2 class="panel-title">Payment Details</h2>
      </div>
      <div class="panel-body">
        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('cad_NameOnCard') }"
        >
          <label for="cad_NameOnCard">Name on card</label>
          <input
            id="cad_NameOnCard"
            name="cad_NameOnCard"
            v-model.trim="fdata.cad_NameOnCard"
            v-validate.initial="{ required: true, max: 100 }"
            maxlength="100"
            class="form-control"
          />
          <span class="help-block">{{ errors.first("cad_NameOnCard") }}</span>
        </div>

        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('cad_Email') }"
        >
          <label for="cad_Email"
            >E-mail (your order will be delivered to this E-mail)</label
          >
          <input
            id="cad_Email"
            name="cad_Email"
            v-model.trim="fdata.cad_Email"
            v-validate.initial="{ required: true, max: 100, email: true }"
            maxlength="100"
            class="form-control"
          />
          <span class="help-block">{{ errors.first("cad_Email") }}</span>
        </div>
        <div class="form-group" v-bind:class="{ 'has-error': cardError }">
          <label for="cad_card">Card</label>
          <div id="cad_card" class="form-control">
            card here
          </div>
          <span class="help-block">{{ cardError }}</span>
        </div>
        <div class="btn-submit-wrapper">
          <div v-if="showAnimation" class="cc-animation">
            <span class="fa fa-spinner fa-spin fa-3x fa-fw"></span><br />
            <span>Payment in progress</span>
          </div>
          <div class="cmi-payment-btn-wrapper">
            <button
              @click="processPayment"
              v-bind:disabled="showAnimation"
              type="submit"
              class="btn btn-lg btn-block btn-primary"
            >
              Pay <span class="cmi-card-amount">$ {{ basketTotal }}</span>
            </button>
          </div>
        </div>
        <div class="stipe-badge-wrapper">
          <img
            class="stipe-badge"
            src="/dist/assets/stripe/powered_by_stripe.png"
          />
        </div>
        <div class="cmi-card-icons">
          <div class="row">
            <div class="col-sm-4 col-xs-6">
              <img
                class="img-responsive"
                alt="We accept Visa"
                title="We accept Visa"
                src="/dist/assets/CardLogos/1.png"
              />
            </div>
            <div class="col-sm-4 col-xs-6">
              <img
                class="img-responsive"
                alt="We accept MasterCard"
                title="We accept MasterCard"
                src="/dist/assets/CardLogos/2.png"
              />
            </div>
            <div class="col-sm-4 col-xs-6">
              <img
                class="img-responsive"
                alt="We accept American Express"
                title="We accept American Express"
                src="/dist/assets/CardLogos/22.png"
              />
            </div>
            <div class="col-sm-4 col-xs-6">
              <img
                class="img-responsive"
                alt="We accept JCB"
                title="We accept JCB"
                src="/dist/assets/CardLogos/16.png"
              />
            </div>
            <div class="col-sm-4 col-xs-6">
              <img
                class="img-responsive"
                alt="We accept Discover"
                title="We accept Discover"
                src="/dist/assets/CardLogos/14.png"
              />
            </div>
            <div class="col-sm-4 col-xs-6">
              <img
                class="img-responsive"
                alt="We accept Diners Club International"
                title="We accept Diners Club International"
                src="/dist/assets/CardLogos/10.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <modal
        name="alert-dialog-card"
        @before-open="beforeOpenDialog"
        @before-close="beforeCloseDialog"
        :width="380"
        :height="'auto'"
        :clickToClose="false"
      >
        <div class="panel-primary">
          <div class="panel-heading modal-alert-heading">
            <span class="modal-alert-title">Information</span>
            <button
              @click="closeAlertDialog"
              type="button"
              class="close pull-right"
            >
              <span
                class="fa fa-times-circle modal-alert-close-button-icon"
              ></span>
            </button>
          </div>
          <div class="panel-body modal-alert-body">
            <div class="modal-alert-text-wrapper">
              <span class="fa fa-exclamation-circle modal-alert-icon"></span>
              <span class="modal-alert-text">
                {{ alertMessage }}
              </span>
            </div>
            <div class="modal-alert-footer">
              <button
                @click="closeAlertDialog"
                type="button"
                class="btn btn-primary"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
const stripeKey =
  "pk_test_51HMHeuDw4NqbT9Hu55wCGNKpc7J2CMBd5eNEt7FFNpQ4aKdsp5rOXSgqFuJdtQ6Gg40HlEZ3c6NYkKvMlrrziw8C00gqLfa4U3";
export default {
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      fdata: {
        cad_NameOnCard: "",
        cad_Email: "",
        cad_Amount: null
      },
      mdata: {
        intentId: "",
        items: []
      },
      showAnimation: false,
      alertMessage: "",
      alertParams: null,
      cardElement: null,
      cardError: "",
      stripe: null
    };
  },
  methods: {
    ...mapActions(["getToken"]),
    ...mapMutations(["showPayment"]),
    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog-card");
    },
    beforeOpenDialog: function({ params }) {
      if (params) {
        this.alertParams = params.status;
      }
    },
    beforeCloseDialog: function() {
      if (this.alertParams == 2) {
        this.showPayment(false);
        this.alertParams = null;
        window.location.href = "/shop-products";
      }
    },
    showBasket: function() {
      this.showPayment(false);
    },
    processPayment: async function() {
      const valStatus = await this.$validator.validateAll();
      if (!valStatus || this.cardError) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-card");
        return;
      }
      this.showAnimation = true;
      const pResult = await this.stripe.confirmCardPayment(
        this.getIntent.clientSecret,
        {
          payment_method: {
            card: this.cardElement,
            billing_details: {
              name: this.fdata.cad_NameOnCard,
              email: this.fdata.cad_Email
            }
          }
        }
      );
      this.showAnimation = false;
      if (pResult.error) {
        if (this.cardError) {
          this.alertMessage = "Form contains validation warnings";
        } else {
          this.alertMessage =
            "Payment failed, please check that your card details are correct and try again";
        }
        this.$modal.show("alert-dialog-card");
      } else {
        this.alertMessage =
          "Thank you for shopping with us, your order will be in your inbox shortly";
        this.$modal.show("alert-dialog-card", { status: 2 });
        this.$store.commit("resetBasket");
      }
    },
    initialiseCardElements: async function() {
      this.stripe = await loadStripe(stripeKey);
      const elements = this.stripe.elements();
      this.cardElement = elements.create("card", {
        hidePostalCode: false,
        style: {
          base: {
            fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
            fontSize: "18px"
          }
        }
      });
      this.cardElement.addEventListener("change", ({ error }) => {
        if (error) {
          this.cardError = error.message;
        } else {
          this.cardError = "";
        }
      });
      this.cardElement.mount("#cad_card");
    },
    saveOrderData: async function() {
      let sData = {
        intentId: this.getIntent.id,
        items: this.getBasket
      };
      this.showAnimation = true;
      const token = await this.this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };

      let rData = null;
      let actionUrl = `${this.baseUrl}SaveOrderData`;
      try {
        ({ data: rData } = await axios.post(actionUrl, sData, config));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }

      if (rData != 0) {
        this.alertMessage =
          "Sorry your order was unsuccessful; we have e-mailed you futher information";
        this.$modal.show("alert-dialog-card");
        this.showAnimation = false;
        return;
      }

      this.alertMessage =
        "Thanks you for shopping with us, your order will be in your inbox shortly";
      this.$modal.show("alert-dialog-card");
      this.showAnimation = false;
    }
  },
  computed: {
    ...mapGetters(["getBasket", "getIntent", "basketTotal"])
  },
  mounted() {
    this.initialiseCardElements();
  }
};
</script>
